module.exports = __webpack_public_path__ + "img/48.7ee80a79.jpg";